// Collection ID constants used across HR and CMS collection pages

export const CENSUS_ID_1940 = '2000219'
export const CENSUS_ID_1950 = '4464515'
export const IGI_ID = '5'

// IGI-specific wiki link
export const IGI_WIKI_LINK = '/wiki/en/International_Genealogical_Index_(IGI)_-_FamilySearch_Historical_Records'

// US Census collection IDs (1910–1950) — flag-gated for isolated CMS page release
export const US_CENSUS_CMS_COLLECTION_FLAG_IDS = new Set([
  '1727033', // 1910
  '1488411', // 1920
  '1810731', // 1930
  '2000219', // 1940
  '4464515', // 1950
])

// Collections released under search_cmsCollectionsMay2026 flag (FSS-13911)
export const MAY_2026_COLLECTION_IDS = new Set([
  '5000016', // United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007
  '1865747', // England and Wales Census, 1891
  '1888129', // England and Wales Census, 1901
  '2562194', // England and Wales Census, 1881
  '1410397', // Indiana Marriages, 1811-2019
  '1538354', // England and Wales Census, 1871
  '2143225', // New York, New York City Marriage Records, 1829-1938
  '2031191', // Texas Marriages, 1966-2010
  '2563939', // England and Wales Census, 1851
  '1589502', // Pennsylvania, County Marriages, 1885-1950
  '1493745', // England and Wales Census, 1841
  '1708654', // Nebraska Marriages, 1855-1995
  '1928860', // Massachusetts State Vital Records, 1841-1925
  '1949336', // North Carolina Birth Index, 1800-2000
  '1804002', // California, County Marriages, 1850-1953
  '1493747', // England and Wales Census, 1861
  '1463134', // Illinois, Cook County Deaths, 1871-1998
  '1473014', // England Births and Christenings, 1538-1975
  '1804888', // Kentucky, County Marriages, 1797-1954
  '2848682', // North Carolina, Department of Archives and History, Index to Vital Records, 1800-2000
  '1807364', // Louisiana Parish Marriages, 1837-1957
  '2531527', // Kentucky, Vital Record Indexes, 1911-1999
  '1949339', // California Marriage Index, 1960-1985
  '4439317', // England, Yorkshire, Parish Registers, 1538-2016
])

// Collections released under search_cmsCollectionsJune2026 flag (FSS-14365)
export const JUNE_2026_COLLECTION_IDS = new Set([
  '4325045', // United States, GenealogyBank Obituaries, 1980-2014
  '1726975', // Colombia, Catholic Church Records, 1576-2019
  '2704829', // Netherlands, Archival Indexes, Vital Records
  '1452460', // Hungary Civil Registration, 1895-1980
  '3405096', // Chile, Catholic Church Records, 1633-2015
  '3015626', // Germany, Lutheran Baptisms, Marriages, and Burials, 1500-1971
  '2765317', // Brazil, São Paulo, Civil Registration, 1925-2023
  '2861657', // Philippines, Catholic Church Records, 1520-2014
  '2135627', // Honduras, Civil Registration, 1841-1968
])

// Wiki-about enabled collections (graduated from search_cmsCollectionsWikiCollections flag, FSS-14300)
export const WIKI_COLLECTION_IDS = new Set([
  '5000145', // United States, Obituary Records, 2014-2023
  '2333694', // United States, GenealogyBank Obituaries, Births, and Marriages 1980-2014
  '1949342', // Texas Birth Index, 1903-1997
  '1743384', // Alabama County Marriages, 1809-1950
  '2370234', // Virginia, Marriage Certificates, 1936-1988
  '2860782', // United States, GenealogyBank Historical Newspaper Obituaries, 1815-2011
  '1949334', // Minnesota Birth Index, 1935-2002
  '1614804', // Ohio, County Marriages, 1789-2016
  '1921547', // England and Wales Census, 1911
  '1726957', // North Carolina, County Marriages, 1762-1979
  '1325221', // United States Census, 1900
  '1417683', // United States Census, 1880
  '1438024', // United States Census, 1870
  '1473181', // United States Census, 1860
  '1401638', // United States Census, 1850
])
